export default function () {
  /* 表格列头 */
  return [
    { label: "序号", type: "index", width: 80 },
    { label: "出诊名称", prop: "ticketType" },
    { label: "预约人数", prop: "num", width: 80 },
    // { label: "出诊ID", prop: "activeID", width: 80  },
    // { label: "患者姓名", prop: "name", width: 150 },
    { label: "联系电话", prop: "phone" },
    // { label: "图片预览", prop: "imgUrl",slots:"imgUrl" },
    { label: "状态", prop: "status", slots: "status", width: 120 },
    // { label: "余量(元)", prop: "money", width: 120},
    { label: "交易号", prop: "out_trade_no", width: 140},
    // { label: "操作人ID", prop: "heixaoID", width: 100},
    {
      label: "创建日期",
      prop: "createTime",
      width: 180,
    },
    {
      label: "操作",
      prop: "operation",
      width: 160,
      slots: "operation",
      fixed: "right",
    },
  ];
}
